module.exports = __webpack_public_path__ + "media/images/star-half-12cb7462.svg";